export const AGENTS = {
  ceo: {
    id: "ceo",
    name: "Casey",
    role: "Co-founder / CEO",
    tagline: "Your ride-or-die partner. Chats through ideas & priorities.",
    color: "#C0C4CC",
    gradient: "linear-gradient(135deg,#F1F5F9 0%,#94A3B8 100%)",
    ring: "ring-neon-chrome",
    accent: "chrome",
    avatar: "https://images.unsplash.com/photo-1740252117027-4275d3f84385?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
  },
  marketer: {
    id: "marketer",
    name: "Mica",
    role: "Marketer",
    tagline: "Drafts posts, schedules, and generates visuals.",
    color: "#FF007F",
    gradient: "linear-gradient(135deg,#FF007F 0%,#FF9900 100%)",
    ring: "ring-neon-pink",
    accent: "pink",
    avatar: "https://images.unsplash.com/photo-1740252117012-bb53ad05e370?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
  },
  sales: {
    id: "sales",
    name: "Rex",
    role: "Sales Rep",
    tagline: "Handles leads, drafts outreach, chases follow-ups.",
    color: "#00FFFF",
    gradient: "linear-gradient(135deg,#00FFFF 0%,#39FF14 100%)",
    ring: "ring-neon-cyan",
    accent: "cyan",
    avatar: "https://images.unsplash.com/photo-1740252117013-4fb21771e7ca?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
  },
  accountant: {
    id: "accountant",
    name: "Ada",
    role: "Accountant",
    tagline: "Tracks money. Never files. Flags cash runway risk.",
    color: "#6366F1",
    gradient: "linear-gradient(135deg,#818CF8 0%,#A78BFA 100%)",
    ring: "ring-indigo-400",
    accent: "purple",
    avatar: "https://images.unsplash.com/photo-1740252117070-7aa2955b25f8?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
  },
};
